module.exports = __webpack_public_path__ + "img/logo.3f316cc9.svg";